import {
  langType,
  countryType,
  IFooterConfig,
  IFooterConfigAllwithDefault,
  IChangeLanguage,
} from '../interface/IFooter';
import { footerL10n, footerL10nLang } from './L10n';

const DEFAULT_CONFIG: Required<IFooterConfig> = {
  countryList: [],
  languageList: [],
  languageCountryList: [],
  snsList: [],
  linkList: [],
  gameGrade: '',
  csInfoType: 'mobile',
  copyright: '',
  companyLink: '',
  keepPath: false,
  keepPathForLang: true,
  operationPolicyLink: '',
  communityPolicyLink: '',
  cookiePolicyLink: '',
  legalDocumentationLink: '',
  gameGradeLink: '',
  termsOfUseLink: '',
  familySiteList: [],
  isKakaoGamesChannel: false,
  isCsInfoNCV: false,
  isCsInfoNCA: false,
  isCsInfoHEROSE: false,
  isCsInfoNCA_bns: false,
  isCsInfoNCA_aion: false,
  isCsInfoNCA_lineage2: false,
};

export default class DataStore {
  private static _instance: DataStore;

  public lang!: langType;
  public langForL10n!: langType;
  public country!: countryType;
  public service!: string;
  public config!: IFooterConfig;
  public l10n!: FooterL10n;
  public l10nLang!: IChangeLanguage;
  public countryData!: Array<{ country: string; text: string }>;
  public geoCountry!: countryType;

  private constructor() {}

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  public init(_config: IFooterConfigAllwithDefault) {
    const htmlEl = document.querySelector('html');
    if (htmlEl) {
      this.langForL10n = this.getLangForL10n(); // footer 에 들어가는 문구의 l10n을 위한 lang 값 (html lang갓 es는 상황에 따라 es-mx, es-es 두개로 나눌수 있고, l10n을 위한 내용이 다르다)
      this.lang = (htmlEl.getAttribute('lang') || 'ko') as langType; // 그냥 진짜 html lang 값 가져오기.
      this.country = (htmlEl.getAttribute('data-country') ||
        'KR') as countryType;
      this.service = htmlEl.getAttribute('data-service') || 'plaync';
      this.l10n = footerL10n[this.langForL10n];
      this.l10nLang = footerL10nLang; // 각 나라의 언어를 표현하는 문자를 각 나라의 언어로 표현한것
      this.config = this.setConfig(_config);
      this.countryData = this.sortCountry(this.config.countryList);
      for (var i in window) {
        if (i === '_geolocationCountry') {
          this.geoCountry = window[i] as unknown as countryType;
        }
      }
    }
  }

  setConfig(_config: IFooterConfigAllwithDefault): IFooterConfig {
    let defaultConfig: IFooterConfig = Object.assign(
      {},
      DEFAULT_CONFIG,
      _config.default
    );
    let currentConfig: IFooterConfig = _config[this.country];

    if (currentConfig) {
      Object.assign(defaultConfig, currentConfig);
    }

    return defaultConfig;
  }

  sortCountry(_countryList: Array<countryType>) {
    const countryL10n = _countryList.map((it) => {
      return {
        country: it,
        text: this.l10n.country[it],
      };
    });

    return countryL10n.sort((a, b) => a.text.localeCompare(b.text, this.lang));
  }

  getLangForL10n(): langType {
    const htmlLang = document
      .querySelector('html')!
      .getAttribute('lang')
      ?.toLowerCase();
    const htmlDataCountry = document
      .querySelector('html')!
      .getAttribute('data-country')
      ?.toLowerCase();
    const userDataLocale = window.userData?.locale?.toLowerCase();

    /**
     * "스페인어-유럽" 과, "스페인어-남미" 의 언어코드가 다르다.
     * 언어는 같은데(es) locale 값이 다르고(es-ES, es-MX), locale 값에 따라 사용되는 번역이 다르다.
     * 그래서 기획과 백엔드와 프론트가 아래와 같이 협의를 진행하였다.
     *
     * 1) html lang 속성에는 기존과 같이 lang 값만 줄것이다. (스페인어 인경우 무조건 es)
     * 2) 단, es 만 가지고, l10n에 es_ES을 사용할지, ex_MX를 쓸지 모르므로,
     * 3) 처음에 cnb 에서 불러오는 userData.locale을 통해 분기를 태우고
     * 4) cnb 가 없는 페이지의 경우도 있으니,  data-country를 통해 분기를 태운다.
     *
     * [TODO] 중국어-간체 가 추가될때도 비슷하게 진행될것 같다.
     */
    if (htmlLang === 'es') {
      // 1) userData 먼저 보고
      if (userDataLocale) {
        if (/-es$/i.test(userDataLocale)) {
          return 'es_ES';
        } else {
          return 'es_MX';
        }
        // 2) dataCountry 보고
      } else if (htmlDataCountry) {
        if (/^es$/i.test(htmlDataCountry)) {
          return 'es_ES';
        } else {
          return 'es_MX';
        }
        // 3) 둘다 없으면
      } else {
        return 'es_ES';
      }
    } else {
      return htmlLang as langType;
    }
  }
}
